import toast from "react-hot-toast";
import useForm from "../hooks/useForm";
import useTable from "../hooks/useTable";
import Addandeditform from "../shared/components/CurrentAffairs/AddandEditform";
import Tableheadpanel from "../shared/components/CurrentAffairs/Tableheadpanel";
import { apideleteCurrentaffairs, apigetallCurrentaffairs, apisaveCurrentaffairs, apiupdateCurrentaffairs } from "../shared/services/apiCurrentaffairs/apicurrentaffairs";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Datatable from "../shared/components/CurrentAffairs/Datatable";
import Cuspagination from "../shared/components/Courses/Cuspagination";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import Addhookform from "../shared/components/CurrentAffairs/Addhookform";
import { useState } from "react";

export default function CurrentaffairsPage () {

    const { page, first, rows, globalFilter, setGlobalFilter, onPage } = useTable();
    const { formdata, handlechange, visible, setVisible, openform, resetForm,editform ,hookVisible,setHookVisible,openHooksForm} = useForm({});
    const queryClient = useQueryClient();

    const { data } = useQuery({ queryKey: ['notificationData', page, rows, globalFilter], queryFn: () => apigetallCurrentaffairs({ first, rows, globalFilter }) })
    const handlesave = async (e) => {
        e.preventDefault();
        console.log("Form data being saved:", formdata);
        const res = await apisaveCurrentaffairs(formdata);
        console.log("API response:", res);
        res.message == "Successfully saved" ? handlesuccess(res) : toast.error(res.message);
      }

      const handlesuccess = (res) => {
        toast.success(res.message)
        queryClient.invalidateQueries('currentAffairsData');
        resetForm();
    }

    const handleupdate = async (e) => {
        e.preventDefault();
        const { _id, ...Othersdata } = formdata
        const res = await apiupdateCurrentaffairs(_id, Othersdata);
        res.message == "Successfully updated" ? handlesuccess(res) : toast.error(res.message);
    }

    const handledelete = async (_id) => {
        const res = await apideleteCurrentaffairs(_id);
        res.message == "Successfully deleted" ? handlesuccess(res) : toast.error(res.message);
      }

    const confirm2 = (_id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger bg-red-500 ml-2 text-white py-2 px-3',
            rejectClassName: 'ml-2  py-2 px-3',
            accept: () => { handledelete(_id) }
        });
    };

    return (
        <>
        <Addandeditform visible={visible} setVisible={setVisible} formdata={formdata} handlechange={handlechange} handlesave={handlesave} handleupdate={handleupdate} />
        <Tableheadpanel setGlobalFilter={setGlobalFilter} openform={openform} openHooksForm={openHooksForm}/>
        <Datatable data={data} editform={editform} confirm2={confirm2}/>
        {data?.totallength > 0 && (<Cuspagination page={page} rows={rows} onPage={onPage} totallength={data?.totallength} />)}
        <Addhookform hookVisible={hookVisible} setHookVisible={setHookVisible} />
        <ConfirmDialog />
        </>
    )
}